import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    metaInfo: {
      title: '',
      keywords: '',
      description: ''
    }
  },
  mutations: {
    CHANGE_META_INFO(state, metaInfo) {
      state.metaInfo = { ...state.metaInfo, ...(metaInfo || {}) }
    }
  },
  actions: {
    setMetaInfo({ commit }, metaInfo) {
      commit('CHANGE_META_INFO', metaInfo)

      if (typeof document !== 'undefined') {
        if (metaInfo && metaInfo.title !== undefined) {
          document.title = metaInfo.title || ''
        }
        const ensureMeta = (name) => {
          let el = document.querySelector(`meta[name="${name}"]`)
          if (!el) {
            el = document.createElement('meta')
            el.setAttribute('name', name)
            document.head.appendChild(el)
          }
          return el
        }
        if (metaInfo && metaInfo.keywords !== undefined) {
          ensureMeta('keywords').setAttribute('content', metaInfo.keywords || '')
        }
        if (metaInfo && metaInfo.description !== undefined) {
          ensureMeta('description').setAttribute('content', metaInfo.description || '')
        }
      }
    }
  },
  modules: {
    app
  }
}) 